import jsonData from "./booking_log.json";
import Types from '../Types.mjs'

class BookingLog extends Types {
    constructor(params = {}) {
      super({TYPES: jsonData});
    }
};

export default BookingLog = new BookingLog();